import apptracker from '@utils/sensor/apptracker';

// list of events we don't want to track any more
const deprecated: string[] = [];

// value injected during building
const mode = process.env.logMode;

function track(props) {
  const { event, data } = props;
  if (!event || deprecated.includes(event)) {
    return;
  }
  switch (mode) {
    case 'console':
      window.console.log(props);
      break;
    default:
  }

  // push events to sensor
  apptracker(event, data);
}

export default track;

export function perfTrack(props = {}) {
  if (mode === 'console') {
    window.console.log(props);
    return;
  }
  // push events to sensor
  apptracker(TOTAL_PAGE_LOAD_TIME, { ...props, url: location.href });
}

export const PULSE_INITIALIZATION_ERROR = 'Pulse Initialization Error';

export const CLICK_COMPARE = 'Click Compare';
export const CLICK_TOP_TRENDS_BY = 'Click Top Trends By';
export const CLICK_DIAGNOSTICS = 'Click Diagnostics';
export const APPLY_METRICS = 'Apply Metrics in Dimension Panel';
export const CLICK_FILTERS = 'Click Filters Dropdown';
export const APPLY_DRILL_DOWN = 'Apply drill-down filter';

export const CLICK_DATE_COMPARISON_ON = 'Click Visual Time Shift ON';
export const CLICK_DATE_COMPARISON_OFF = 'Click Visual Time Shift OFF';
export const CLICK_CLOSE_DIAGNOSTICS = 'Click on Close Diagnostics';

export const CLICK_EXPORT_COMPARE_DASHBOARD = 'Click Export Compare Dashboard';
export const CLICK_EXPORT_ERROR_DIAGNOSTICS = 'Click Export Error Diagnostics';
export const CLICK_EXPORT_WIDGET_TRENDS_METRIC = 'Click Export Widget Trends Metric';
export const CLICK_EXPORT_WIDGET_TRENDS_ALL_METRICS = 'Click Export Widget Trends All Metrics';
export const CLICK_EXPORT_TRENDS = 'Click Export Trends';
export const CLICK_EXPORT_OVERVIEW = 'Click Export Overview';

export const CLICK_EXPORT_WIDGET_ERROR_BIRD_CHART = 'Click Export Widget Error Bird Chart';
export const CLICK_EXPORT_WIDGET_ERROR_BAR_CHART = 'Click Export Widget Error Bar Chart';
export const CLICK_EXPORT_TRENDS_VIEWER_DRILLDOWN_DISTRIBUTION =
  'Click Export trends viewer drilldown distribution';
export const CLICK_EXPORT_WIDGET_TRENDS_DIAGNOSTICS = 'Click Export widget trends Diagnostics';
export const CLICK_EXPORT_WIDGET_COMPARE = 'Click export widget compare';
export const CLICK_EXPORT_WIDGET_TRENDS_SESSIONS = 'Click export widget trends sessions';
export const CLICK_EXPORT_WIDGET_ERROR_TOP_TRENDS_ERROR_TABLE =
  'Click export widget error top trends table';
export const CLICK_EXPORT_WIDGET_TRENDS_DIMENSIONS = 'Click export widget trends dimensions';

export const CLICK_ALL_METRICS_PANEL_APPLY = 'Click all metrics panel apply';
export const CLICK_DATE_COMPARISON = 'Click date comparison';

export const CLICK_SAVE_REORDER_POLICIES = 'Click on save reordering of policies';
export const CLICK_SAVE_ACTIVATE_POLICY_NOW = 'Click on activate precision policy now';
export const CLICK_SAVE_SCHEDULE_POLICY = 'Click on save schedule precision policy';
export const CLICK_EDIT_ACTIVATE_POLICY_NOW = 'Click on edit and activate precision policy now';
export const CLICK_EDIT_SCHEDULE_POLICY = 'Click on edit precision policy schedule';
export const CLICK_EDIT_REORDER_POLICY_NOW = 'Click on edit and reorder policies now';
export const CLICK_EDIT_SCHEDULE_POLICY_REORDER = 'Click on edit reorder schedule';
export const CLICK_DELETE_SCHEDULE_POLICY = 'Click on delete precision policy schedule';
export const CLICK_SCHEDULE_POLICY_LIST_VIEW = 'Click on scheduled policies list view';
export const CLICK_SCHEDULE_POLICY_CALENDAR_VIEW = 'Click on scheduled policies calendar view';

export const CLICK_ML_NEW_FILTER = 'Click on MetricLens new filter';
export const CLICK_ML_LIVE = 'Click on MetricLens live.';
export const CLICK_ML_DIMENSION_CHANGE = 'Click on MetricLens dimension change';
export const CLICK_ML_METRICS_CHANGE = 'Click on MetricLens metrics change';
export const CLICK_ML_CHART_MODE_CHANGE = 'Click on MetricLens chart mode change';
export const CLICK_ML_UNIT_MODE_CHANGE = 'Click on MetricLens unit mode change';
export const CLICK_ML_DATETIME_INTERVAL_CHANGE = 'Click on MetricLens date time interval change';
export const CLICK_ML_SORTING = 'Click on MetricLens sorting';
export const CLICK_ML_FILTER_CLOSE = 'Click on MetricLens filter close';

export const AUTO_INSIGHTS_DRAWER = 'Opened auto insights drawer';
export const AUTO_INSIGHTS_SETTINGS = 'Clicked on auto insights settings';
export const AUTO_INSIGHTS_ALERT_CLICK = 'Clicked on auto insights AI alert record';
export const AUTO_INSIGHTS_ALERTS_MORE = 'Clicked on auto insights AI alert more link';
export const ALERT_INSIGHTS = 'Clicked on alert summary insights link';
export const AUTO_INSIGHTS_BROKENASSET_CLICK = 'Clicked on auto insights Broken Asset record';
export const AUTO_INSIGHTS_NEWAPPVERSION_CLICK = 'Clicked on auto insights New App Version record';

export const CLICK_EXPORT_AI_ALERTS_SUMMARY_TABLE = 'Click Export AI Alerts Summary Table';

export const CHANGED_TIME_GRANULARITY = 'Changed time granularity';
export const CHANGED_METRIC_PANEL_LAYOUT = 'Changed metric panel layout';
export const WHATS_NEW_HELP = 'Clicked whats new button';
export const TRY_APP_INSIGHTS = 'Clicked try app insights button';

export const SELECTED_CHART_METRIC = 'Selected chart metric';
export const CLICK_CHART_TOOL = 'Clicked on chart tool';
export const CLICK_CHART_MODE = 'Clicked on chart mode';
export const CHANGE_CHART_SIZE = 'Changed chart size';
export const CHANGE_CHART_UNIT = 'Changed chart unit';
export const REMOVE_CHART = 'Removed chart';
export const SELECTED_SUMMARY_PANEL_METRIC = 'Selected summary panel metric';
export const CLICK_SUMMARY_PANEL_COLLAPSE = 'Clicked on summary panel collapse';

export const CLICK_SHARE_FROM_KEBAB = 'Click on Share from kebab menu';
export const CLICK_SAVE_FROM_KEBAB = 'Click on Save dashboard from the kebab menu';
export const CLICK_ON_UPDATE_DASHBOARD = 'Click on Update dashboard from the kebab menu';
export const CLICK_ON_DELETE_DASHBOARD = 'Click on Delete dashboard from the kebab menu';
export const CLICK_ON_CLONE_DASHBOARD = 'Click on Clone dashboard from the kebab menu';
export const CLICK_ON_PRIVATE_PUBLIC_CHECKBOX = 'Make it public/private';
export const CANCEL_SAVE_DASHBOARD_POPUP = 'Cancel save dashboard popup';
export const CANCEL_UPDATE_DASHBOARD_POPUP = 'Cancel update dashboard popup';
export const CANCEL_DELETE_DASHBOARD_POPUP = 'Cancel delete dashboard popup';
export const CLICK_SAVED_DASHBOARD_TABS = 'Click on saved dashboard tabs';
export const CLICK_SAVED_DASHBOARD_COLUMN_SORT = 'Click on saved dashboard column sort';
export const CLICK_SHARE_ON_SAVED_DASHBOARD_LIST = 'Saved Dashboard row action - share';
export const CLICK_EDIT_ON_SAVED_DASHBOARD_LIST = 'Saved Dashboard row action - edit';
export const CLICK_CLONE_ON_SAVED_DASHBOARD_LIST = 'Saved Dashboard row action - clone';
export const CLICK_DELETE_ON_SAVED_DASHBOARD_LIST = 'Saved Dashboard row action - delete';
export const CLICK_SAVED_DASHBOARD_FROM_TABS_DROPDOWN =
  'Saved dashboards accessed from the tabs dropdown';
export const CLICK_SAVED_DASHBOARD_FROM_NAV_MENU_DROPDOWN =
  'Saved dashboards accessed from the navigation menu dropdown';
export const CLICK_ON_CLOSE_UNSAVED_DASHBOARD = 'Closing an unsaved dashboard';
export const USER_FEEDBACK = 'user feedback';

export const DIMENSION_METRIC_DRAG_END = 'Dimension Metrics reorder Drag End';

export const APP_TRIAL_REQUEST = 'App Insights Trial Request';

export const PRESET_USECASE = 'preset usecase';
export const TOGGLE_ERROR_FILTER = 'toggle error filter';

// web performance
export const TOTAL_PAGE_LOAD_TIME = 'Total page load time';

export const PROMPT_FEEDBACK = 'Prompt Feedback';
export const PROMPT_QUESTION = 'Prompt Question';
export const PROMPT_ANSWER = 'Prompt Answer';
export const PROMPT_ERROR = 'Prompt Error in UI';
export const PROMPT_COPY_ANSWER = 'Prompt Copy';
export const PROMPT_SUGGEST_QUESTION = 'Prompt Suggest Question';
export const PROMPT_SUBMIT_QUESTION = 'Prompt submit question';
export const PROMPT_CHUNK_ARRIVED = 'Prompt chunk arrived';
export const PROMPT_FIRST_CHUNK = 'Prompt first chunk';
export const PROMPT_LAST_CHUNK = 'Prompt last chunk';

export const AI_SUMMARY_GENERATE = 'AI Summary Generate';

export const QUICK_COMPARE = 'Quick compare toggle';
export const APPLY_COMPARE = 'Apply Compare';

// compare dashboard migration
export const COMPARE_MIGRATION = 'compare dashboard migration';
export const MIGRATED_COMPARE_DASHBOARD = 'migrated compare dashboard';
export const COMPARE_MIGRATION_ERROR = 'compare dashboard migration error';

// error diag dashboard migration
export const ERROR_DIAG_MIGRATION = 'error diag dashboard migration';
export const MIGRATED_ERROR_DIAG_DASHBOARD = 'migrated error diag dashboard';
export const ERROR_DIAG_MIGRATION_ERROR = 'error diag dashboard migration error';

// Dimension Management
export const OPEN_DIMENSION_MANAGEMENT_PANEL = 'Open Dimension Management Panel';
export const EDIT_DIMENSION_COMPLETE_DIMENSION_MANAGEMENT =
  'Edit Dimension Complete Dimension Management';
export const CREATE_BUTTON_ON_DIMENSION_MANAGEMENT = 'Create Button On Dimension Management Panel';
export const DELETE_DIMENSION_ON_DIMENSION_MANAGEMENT =
  'Delete Dimension On Dimension Management Panel';

//Geo Map
export const TOGGLE_TO_MAP_VIEW = 'Toggle To Map View';
export const CLICK_EXPORT_RESILIENCY_TABLE = 'Click Export Resiliency Table';
export const NEW_RESILIENCY_DASHBOARD_PAGE_VIEWED = 'New Resiliency Dashboard Page Viewed';
// unit toggle
export const COMMON_UNIT_TOGGLE_VALUE_CHANGE = 'Click On Common Unit Toggle';
// drill down icon in App dimension table.
// Event name is a protocol value — analytics dashboards query by the literal
// string. Do NOT rebrand to 'App' or historical dashboards go silent.
export const CLICK_DRILL_DOWN_ICON = 'Click On DPI Drill Down Icon';

// New Filter Builder and Filter Management Event Tracking
// https://conviva.atlassian.net/wiki/spaces/CPT/pages/2567242250/Filter+Builder+Event+Tracking+Summary
export const OPEN_FILTER_MANAGEMENT_PANEL = 'Open Filter Management Panel';
export const CREATE_FILTER_ON_FILTER_MANAGEMENT = 'Create Filter On Filter Management Panel';
export const DELETE_FILTER_ON_FILTER_MANAGEMENT = 'Delete Filter On Filter Management Panel';
export const OPEN_FILTER_BUILDER = 'Open Filter Builder';
export const APPLY_FILTER_ON_FILTER_BUILDER = 'Apply Filter On Filter Builder';
export const SAVE_AND_APPLY_FILTER_ON_FILTER_BUILDER = 'Save And Apply Filter On Filter Builder';
export const SAVE_FILTER_ON_FILTER_BUILDER = 'Save Filter On Filter Builder';
export const CLEAR_FILTER_ON_FILTER_BUILDER = 'Clear Filter On Filter Builder';
export const APPLY_SAVED_FILTER_ON_FILTER_BUILDER = 'Apply Saved Filter On Filter Builder';
export const BROWSER_FILTER_MANAGEMENT_ON_FILTER_BUILDER =
  'Browser Filter Management On Filter Builder';
export const FILTER_BUILDER_TOGGLE_EXPAND_CONDITIONS =
  'Filter Builder: Toggle Expand Conditions On Simple Mode';
export const FILTER_BUILDER_APPLY_DIMENSION_ON_SIMPLE_MODE =
  'Filter Builder: Apply Dimension On Simple Mode';
export const FILTER_BUILDER_APPLY_CUSTOM_TAG_ON_SIMPLE_MODE =
  'Filter Builder: Apply Custom Tag On Simple Mode';
export const FILTER_BUILDER_CHANGE_CONDITION_OPERATOR_ON_SIMPLE_MODE =
  'Filter Builder: Change Condition Operator On Simple Mode';
export const FILTER_BUILDER_CHANGE_CONDITION_DIMENSION_ON_SIMPLE_MODE =
  'Filter Builder: Change Condition Dimension On Simple Mode';
export const FILTER_BUILDER_CHANGE_CONDITION_VALUES_ON_SIMPLE_MODE =
  'Filter Builder: Change Condition Values On Simple Mode';
export const FILTER_BUILDER_REMOVE_CONDITION_ITEM_ON_SIMPLE_MODE =
  'Filter Builder: Remove Condition Item On Simple Mode';
export const FILTER_BUILDER_APPLY_CHANGES_ON_SIMPLE_MODE =
  'Filter Builder: Apply Changes on Simple Mode';
export const FILTER_BUILDER_REMOVE_CONDITION_ITEM_ON_ADVANCED_FILTER =
  'Filter Builder: Remove Condition Item On Advanced Filter';
export const FILTER_BUILDER_CHANGE_CONDITION_OPERATOR_ON_ADVANCED_FILTER =
  'Filter Builder: Change Condition Operator On Advanced Filter';
export const FILTER_BUILDER_EXIT_ADVANCED_FILTER_MODE = 'Filter Builder: Exit Advanced Filter';
export const FILTER_BUILDER_ENTER_ADVANCED_FILTER_MODE = 'Filter Builder: Enter Advanced Filter';
export const FILTER_BUILDER_APPLY_ACTION_TYPE = 'Filter Builder: Apply Action Type';
export const FILTER_MANAGEMENT_BULK_DELETE = 'Filter Management: Bulk Delete Saved Filters';
export const FILTER_BUILDER_SAVED_FILTER_SEARCH = `Filter Builder: Saved Filter Search`;
export const FILTER_MANAGEMENT_SAVED_FILTER_SEARCH = `Filter Management: Saved Filter Search`;

export const AUTO_Y_AXIS_TOGGLE = 'Dynamic Y-Axis Toggle';

// Metric Help
export const CLICK_HELP_IN_METRIC_CARD = 'Click On Help In Metric Card';

// Trends Auto Refresh Toggle
export const AUTO_REFRESH_TOGGLE = 'Auto Refresh Toggle';

export const LAYOUT_CHANGE = 'Layout Change';
export const SWAP_METRIC = 'Swap Metric';
export const ADD_WIDGET = 'Add Widget';
export const CONFIGURED_METRIC_GROUP_WIDGET = 'Configured Metric Group Widget';
export const CONFIGURED_FLOW_WIDGET = 'Configured Flow Widget';
export const WIDGET_DRILLDOWN = 'Widget Drilldown';

export const CLICK_TIMELINE_CUSTOMIZE_APPLY = 'Click timeline customize apply';

// Email subscriptions
export const OPEN_EMAIL_SUBSCRIPTIONS_DRAWER = 'Open Email Subscriptions';
export const OPEN_MORE_CHANNELS_DRAWER = 'Open More Channels';
export const CREATE_NEW_EMAIL_SUBSCRIPTIONS = 'Create New Email Subscriptions';
export const UPDATE_EMAIL_SUBSCRIPTION = 'Update Email Subsciption';
export const UNSUBSCRIBE_EMAIL_SUBSCRIPTIONS = 'Unsubscribe Email Subscriptions';

//Event Metric Widget
export const EVENT_METRIC_WIDGET_EVENT_CHANGE = 'Event Metric Widget Event Change';
export const EVENT_METRIC_WIDGET_METRIC_CHANGE = 'Event Metric Widget Metric Change';

// AI Alerts
export const OPEN_SENSITIVITY_LOGS = 'Open Sensitivity Logs';
export const OPEN_AI_ALERT_SUMMARY = 'Open AI Alert Summary';

// Click on Preset links in Metrics and Dimensions Popups
export const CLICK_PRESET_LINK_IN_METRICS_POPUP = 'Click on preset link in Metrics Popup';
export const CLICK_PRESET_LINK_IN_DIMENSIONS_POPUP = 'Click on preset link in Dimensions Popup';

// Click DPI  Overview
export const ADD_OVERVIEW_FLOW = 'Add Overview Flow';

// Nexa
export const NEXA_FEEDBACK = 'Nexa Feedback';
export const NEXA_QUERY = 'Nexa Query';
export const NEXA_TEMPLATE_QUERY = 'Nexa Template Query';
export const NEXA_CHAT_STREAM_ERROR = 'Nexa Chat Stream Error';
export const NEXA_DASHBOARD_LINK_CLICK = 'Nexa Dashboard Link Click';
export const NEXA_RESPONSE_COPY = 'Nexa Response Copy';
export const NEXA_TABLE_EXPORT = 'Nexa Table Export';
export const NEXA_ACTION_SHOWN = 'Nexa Action Shown';
export const NEXA_ACTION_CLICK = 'Nexa Action Click';
export const NEXA_ACTION_SELECT = 'Nexa Action Select';
export const NEXA_REPORT_DOWNLOAD = 'Nexa Report Download';
export const NEXA_REPORT_GENERATE = 'Nexa Report Generate';

export const HIGH_CARDINALITY_BUTTON_CLICK = 'High Cardinality Button Click';

//Auth
export const LOGIN_START = 'Login Start';
export const LOGIN_END = 'Login End';
export const LOGIN_SUCCESS = 'Login Success';
